import script from "./InscriptionRedactor.vue?vue&type=script&setup=true&lang=js"
export * from "./InscriptionRedactor.vue?vue&type=script&setup=true&lang=js"

import "./InscriptionRedactor.vue?vue&type=style&index=0&id=0c5db50c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c5db50c"]])

export default __exports__